import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => (
  <div className="bg-[#030B2E] pt-28 text-white min-h-[calc(100vh-6rem)]">
    <div className="container-custom py-20">
      <div className="rounded-[2rem] border border-white/10 bg-white/[0.04] p-10 text-center shadow-[0_24px_80px_rgba(0,0,0,0.25)]">
        <h1 className="text-4xl font-bold text-[#17E6B3]">Página não encontrada</h1>
        <p className="mt-4 text-lg text-[#D9E4FF]">
          Parece que a página que você está tentando acessar não existe ou não está disponível no momento.
        </p>
        <Link
          to="/"
          className="mt-8 inline-flex items-center justify-center rounded-2xl bg-[#17E6B3] px-8 py-4 font-semibold text-[#030B2E] transition-colors hover:bg-[#0ed3a3]"
        >
          Voltar para a página inicial
        </Link>
      </div>
    </div>
  </div>
);

export default NotFound;
